import React from "react";

const CRMAnalytics = () => {
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    if (hour < 21) return "Good Evening";
    return "Good Night";
  };

  return (
    <>
      <div className="text-center py-3 border-bottom">
        <h5 className="m-0">
          {getGreeting()}, Roop
        </h5>
        <p className="m-0" style={{ fontSize: 13 }}>
          Welcome to your CRM Dashboard. Manage leads, track performance, and stay on top of your business at a glance.
        </p>
      </div>
    </>
  );
};

export default CRMAnalytics;
